module.exports = __webpack_public_path__ + "img/mo.e26a4c9d.svg";